import React, { useEffect, useState } from 'react';
import { Video } from 'lucide-react';
import authApi from '../../auth.api';
import { GET_USER_TIKTOK_INFO } from '../../route';
import { toast } from 'react-toastify';

const LinkTiktok = ({ handleLinkTikTok, tiktokLinked }) => {
  const [tiktokInfo, setCreatorInfo] = useState(null);

  useEffect(() => {
    fetchTikTokInfo();
  }, []);

  const fetchTikTokInfo = async () => {
    const result = await authApi.get(GET_USER_TIKTOK_INFO);
    if (result.status === false) return toast.error(result.message);
    setCreatorInfo(result.data.tikTokInfo);
  };

  return (
    <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 rounded-lg border border-gray-100 space-y-4 sm:space-y-0'>
      <div className='flex items-start space-x-3 w-full sm:w-auto'>
        <Video className='h-5 w-5 text-gray-900 mt-1 flex-shrink-0' />
        <div className='flex-grow min-w-0'>
          <h3 className='text-lg font-semibold text-gray-800 truncate'>
            TikTok
          </h3>
          {tiktokLinked && tiktokInfo && tiktokInfo.tikTokUsername && (
            <p className='text-sm text-gray-600 truncate'>
              @{tiktokInfo.tikTokUsername}
            </p>
          )}
          <p className='text-sm text-gray-500'>
            {tiktokLinked ? 'Account linked' : 'Not linked'}
          </p>
        </div>
      </div>
      <button
        onClick={handleLinkTikTok}
        disabled={tiktokLinked}
        className={`w-full sm:w-auto px-4 py-2 rounded-md whitespace-nowrap ${
          tiktokLinked
            ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
            : 'bg-indigo-600 text-white hover:bg-indigo-700'
        }`}
      >
        {tiktokLinked ? 'Linked' : 'Link Account'}
      </button>
    </div>
  );
};

export default LinkTiktok;
